import gql from 'graphql-tag';
import RouterConst from '../../constant/RouterConst';
import apollo from '../apollo';
import { getEntityListWithAccount } from '../../utils/AppUtil';

const IMPORT_ACCOUNT_RES_MUTATION = `
mutation ($input: AccountRespondentDefinitionsImportInput!) {
  importAccountRespondents(input: $input) {
    id
    status
    overwrite
    fileName
    createdOn
    updatedOn
  }
}
`;

export const uploadAccountRespondents = (file, accountId, token) => {
  const formData = new FormData();
  const fieldName = 'importAccountRespondents';
  formData.append(fieldName, file);
  formData.append('query', IMPORT_ACCOUNT_RES_MUTATION);
  formData.append(
    'variables',
    JSON.stringify({
      input: {
        accountId,
        fieldName,
      },
    }),
  );
  const headers = new Headers();

  headers.append('Authorization', `Bearer ${token}`);
  return fetch(RouterConst.API_END_POINT, {
    method: 'POST',
    headers,
    body: formData,
  }).then(res => res.json());
};

const ANONYMIZE_RESPONDENT_MUTATION = gql`
mutation anonymizeRespondentMutation($input: AnonymizeRespondentInput!) {
  anonymizeRespondent(input: $input) {
    respondentId
  }
}
`;

export const anonymizeRespondent = input => apollo
  .mutate({
    mutation: ANONYMIZE_RESPONDENT_MUTATION,
    variables: {
      input,
    },
  })
  .then(res => res.data);

const REMOVE_FILE_IMFORT = gql`
  mutation deleteRespondentImport($input: DeleteRespondentImportInput!) {
    deleteRespondentImport(input: $input)
  }
`;

export const removeFileImport = input => apollo
  .mutate({
    mutation: REMOVE_FILE_IMFORT,
    variables: {
      input,
    },
  })
  .then(res => res.data);

const ACTIVE_FILE_IMPORT = gql`
  mutation activateAccountRespondentImport($input: ActivateAccountRespondentImportInput!) {
    activateAccountRespondentImport(input: $input) {
      id
      status
      overwrite
    }
  }
`;

export const activeFileImport = input => apollo
  .mutate({
    mutation: ACTIVE_FILE_IMPORT,
    variables: {
      input,
    },
  })
  .then(res => res.data);

const IMPORT_SUPERLINK_ACCOUNT_RES_MUTATION = `mutation ($input: SuperLinkRespondentDefinitionsImportInput!) {
  importSuperLinkRespondents(input: $input) {
    id
    status
    overwrite
    fileName
    messages
    createdOn
    updatedOn
  }
}
  `;

export const uploadSuperlinkRespondents = (file, { accountId, superLinkId }, token) => {
  const formData = new FormData();
  const fieldName = 'importAccountRespondents';
  formData.append(fieldName, file);
  formData.append('query', IMPORT_SUPERLINK_ACCOUNT_RES_MUTATION);
  formData.append(
    'variables',
    JSON.stringify({
      input: {
        superLinkId,
        fieldName,
        accountId,
      },
    }),
  );
  const headers = new Headers();

  headers.append('Authorization', `Bearer ${token}`);
  return fetch(RouterConst.API_END_POINT, {
    method: 'POST',
    headers,
    body: formData,
  }).then(res => res.json());
};

const ACTIVE_SUPERLINK_FILE_IMPORT = gql`
  mutation activateSuperLinkRespondentImport($input: ActivateSuperLinkRespondentImportInput!) {
    activateSuperLinkRespondentImport(input: $input) {
      id
      status
      overwrite
    }
  }
`;

export const activateSuperLinkImport = input => apollo
  .mutate({
    mutation: ACTIVE_SUPERLINK_FILE_IMPORT,
    variables: {
      input,
    },
  })
  .then(res => res.data);

const CREATE_RESPONDENT = gql`
  mutation($input: CreateRespondentInput!) {
    createRespondent(input: $input) {
      respondent {
        id
        firstName
        lastName
        email
        updatedOn
        createdOn
      }
    }
  }
`;

export const createRespondent = input => apollo
  .mutate({
    mutation: CREATE_RESPONDENT,
    variables: {
      input,
    },
    options: {
      refetchQueries: ['Respondents', 'Dashboard'],
    },
  })
  .then(res => res.data);

const UPDATE_RESPONDENT = gql`
  mutation updateRespondent($input: UpdateRespondentDetailsInput!) {
    updateRespondentDetails(input: $input) {
      respondent {
        id
        email
        firstName
        lastName
        gender
        locale
        type
        targetJob {
          id
          name
        }
        notes
      }
    }
  }
`;

export const updateRespondent = input => apollo
  .mutate({
    mutation: UPDATE_RESPONDENT,
    variables: {
      input,
    },
  })
  .then(res => res.data);

const UPDATE_REPONDENT_TARGET_JOB = gql`
  mutation updateRespondentTargetJob($input: UpdateRespondentTargetJobInput!) {
    updateRespondentTargetJob(input: $input) {
      respondent {
        id
        targetJob {
          id
          name
          assessmentTemplate {
            id
            title
          }
        }
      }
    }
  }
`;

export const updateRespondentTargetJob = input => apollo
  .mutate({
    mutation: UPDATE_REPONDENT_TARGET_JOB,
    variables: {
      input,
    },
  })
  .then(res => res.data);

const SEARCH_RESPONDENT_QUERY = gql`
  query($accountId: ID!, $first: Int, $filter: RespondentFilter, $sort: RespondentSortSpecifier) {
    account(id: $accountId) {
      id
      respondents(first: $first, filter: $filter, sort: $sort) {
        edges {
          node {
            id
            email
            firstName
            lastName
          }
        }
      }
    }
  }
`;

export const searchRespondents = ({ aid, query }) => {
  const sort = {
    sortBy: 'updatedOn',
    sortDir: 'DESC',
  };

  const variables = {
    accountId: aid,
    first: 25,
    filter: {
      query,
    },
    sort,
  };

  return apollo
    .query({
      query: SEARCH_RESPONDENT_QUERY,
      variables,
      fetchPolicy: 'network-only',
    })
    .then(({ data }) => {
      const { account } = data;
      const processed = getEntityListWithAccount(account, 'respondents');
      return processed;
    });
};
